import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Preloader } from "@/components/Preloader";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import Galleria from "@/pages/Galleria";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [intro, setIntro] = useState(() => !sessionStorage.getItem("edilkrea_intro"));

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <AnimatePresence>
          {intro && (
            <Preloader
              onDone={() => {
                setIntro(false);
                sessionStorage.setItem("edilkrea_intro", "1");
              }}
            />
          )}
        </AnimatePresence>
        <ScrollToTop />
        <div className="min-h-screen bg-ink text-cream">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/galleria" element={<Galleria />} />
            <Route path="/recensioni" element={<Recensioni />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" theme="dark" />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
